import React, { useEffect, useState } from 'react';
import { Chip, Tooltip, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getAuthToken } from '../../utils/auth';
import RankEmblem from './RankEmblem';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || '/api').replace(/\/+$/, '');

export default function RankChip({ userId }) {
  const { i18n } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const token = getAuthToken();
        const endpoint = userId ? `${API_BASE}/rank/user/${encodeURIComponent(userId)}` : `${API_BASE}/rank/me`;
        const res = await fetch(endpoint, { headers: token ? { 'Authorization': `Bearer ${token}` } : {} });
        const json = await res.json();
        if (mounted) setData(json);
      } catch (_) {}
    })();
    return () => { mounted = false; };
  }, [userId]);

  if (!data || !data.rank) return null;
  const { rank } = data;
  const isEn = i18n.language?.startsWith('en');
  const label = isEn ? (rank.nameEn || rank.nameVi) : (rank.nameVi || rank.nameEn);
  const tip = label;

  return (
    <Tooltip title={tip} placement="top">
      <Chip
        label={label}
        color="primary"
        variant="outlined"
        size="small"
        avatar={
          <Avatar sx={{ bgcolor: 'transparent' }}>
            <RankEmblem rankKey={rank.key} size={18} title={label} />
          </Avatar>
        }
      />
    </Tooltip>
  );
}
